export enum NotificationReasonEnum {
  DUE_DATE_FINISHED = "DUE_DATE_FINISHED",
  JOB_CREATED_BY_ME = "JOB_CREATED_BY_ME",
  JOB_ASSIGNED_TO_ME = "JOB_ASSIGNED_TO_ME",
  JOB_UPDATED = "JOB_UPDATED",
  JOB_LOCK_CHANGED = "JOB_LOCK_CHANGED",
  CHECKLIST_LOCK_CHANGED = "CHECKLIST_LOCK_CHANGED",
  MESSAGE_CREATED_BY_ME = "MESSAGE_CREATED_BY_ME",
  MESSAGE_ASSIGNED_TO_ME = "MESSAGE_ASSIGNED_TO_ME",
  MODULE_RELEASE_BY_ME = "MODULE_RELEASE_BY_ME",
  MODULE_RELEASE_BY_ME_FAILED = "MODULE_RELEASE_BY_ME_FAILED",
  MODULE_UPDATE_BY_ME = "MODULE_UPDATE_BY_ME",
  MODULE_UPDATE_BY_ME_FAILED = "MODULE_UPDATE_BY_ME_FAILED",
  MODULE_MERGED_BY_ME_FAILED = "MODULE_MERGED_BY_ME_FAILED",
  MODULE_MERGED_NEW_BY_ME = "MODULE_MERGED_NEW_BY_ME",
  MODULE_MERGED_BY_ME = "MODULE_MERGED_BY_ME",
  MODULE_OF_COMMUNITY_UPDATED = "MODULE_OF_COMMUNITY_UPDATED",
  OBJECTS_ACTION_EXECUTED = "OBJECTS_ACTION_EXECUTED",
  OBJECTS_ACTION_FAILED = "OBJECTS_ACTION_FAILED",
  SUB_OBJECTS_ACTION_EXECUTED = "SUB_OBJECTS_ACTION_EXECUTED",
  SUB_OBJECTS_ACTION_FAILED = "SUB_OBJECTS_ACTION_FAILED",
  OBJECT_COPY_EXECUTED = "OBJECT_COPY_EXECUTED",
  OBJECT_COPY_FAILED = "OBJECT_COPY_FAILED",
  CLASS_CREATED = "CLASS_CREATED",
  CLASS_CREATE_FAILED = "CLASS_CREATE_FAILED",
  CLASS_EDITED = "CLASS_EDITED",
  CLASS_EDITED_FAILED = "CLASS_EDITED_FAILED",
  CLASS_DELETED = "CLASS_DELETED",
  CLASS_DELETED_FAILED = "CLASS_DELETED_FAILED",
  COMMUNITY_ORG_UPDATE = "COMMUNITY_ORG_UPDATE",
  MODULE_DELETED = "MODULE_DELETED",
  MODULE_DELETE_FAILED = "MODULE_DELETE_FAILED",
  PARENT_SUBCLASS_UPDATE = "PARENT_SUBCLASS_UPDATE",
  PARENT_SUBCLASS_UPDATE_FAILED ="PARENT_SUBCLASS_UPDATE",
  MODULE_CLASS_ALLOCATION_SUCCESS = "MODULE_CLASS_ALLOCATION_SUCCESS",
  MODULE_CLASS_ALLOCATION_FAILED = "MODULE_CLASS_ALLOCATION_FAILED",
  JOB_ROUTINE_BULK_SAVE_SUCCESS = "JOB_ROUTINE_BULK_SAVE_SUCCESS",
  JOB_ROUTINE_BULK_SAVE_FAILED = "JOB_ROUTINE_BULK_SAVE_SUCCESS",
  MODULE_CLASS_RELEASE_SUCCESS = "MODULE_CLASS_RELEASE_SUCCESS",
  MODULE_CLASS_RELEASE_FAILED = "MODULE_CLASS_RELEASE_FAILED",
  OBJECT_CREATED = "OBJECT_CREATED",
  OBJECT_DELETED = 'OBJECT_DELETED',
  OBJECT_LOCATION_CHANGED_FROM = 'OBJECT_LOCATION_CHANGED_FROM',
  OBJECT_LOCATION_CHANGED_TO = 'OBJECT_LOCATION_CHANGED_TO',
  MULTI_OBJECT_RENTAL = 'MULTI_OBJECT_RENTAL',
  MULTI_OBJECT_CREATE_SUCCESS = 'MULTI_OBJECT_CREATE_SUCCESS',
  MULTI_OBJECT_CREATE_FAILED = 'MULTI_OBJECT_CREATE_FAILED',
  OBJECT_IMPORT_STATE_CHANGED = 'OBJECT_IMPORT_STATE_CHANGED',
  OBJECT_IMPORT_SUCCESS = 'OBJECT_IMPORT_SUCCESS',
  OBJECT_IMPORT_FAIL = 'OBJECT_IMPORT_FAIL',
  JOB_IMPORT_STATE_CHANGED = 'JOB_IMPORT_STATE_CHANGED',
  JOB_IMPORT_SUCCESS = 'JOB_IMPORT_SUCCESS',
  JOB_IMPORT_FAIL = 'JOB_IMPORT_FAIL',

  CHECKLIST_TEMPLATE_VERSION_CREATE_SUCCESS = "CHECKLIST_TEMPLATE_VERSION_CREATE_SUCCESS",
  CHECKLIST_TEMPLATE_VERSION_CREATE_FAILED = "CHECKLIST_TEMPLATE_VERSION_CREATE_FAILED",
  CHECKLIST_TEMPLATE_VERSION_ARCHIVE_SUCCESS = "CHECKLIST_TEMPLATE_VERSION_ARCHIVE_SUCCESS",
  CHECKLIST_TEMPLATE_VERSION_ARCHIVE_FAILED = "CHECKLIST_TEMPLATE_VERSION_ARCHIVE_FAILED",
  CHECKLIST_TEMPLATE_VERSION_RELEASE_SUCCESS = "CHECKLIST_TEMPLATE_VERSION_RELEASE_SUCCESS",
  CHECKLIST_TEMPLATE_VERSION_RELEASE_FAILED = "CHECKLIST_TEMPLATE_VERSION_RELEASE_FAILED",

  INVOICE_POSITION_EXTRACTION_WITH_AI_SUCCESS = "INVOICE_POSITION_EXTRACTION_WITH_AI_SUCCESS",
  INVOICE_POSITION_EXTRACTION_WITH_AI_FAILED = "INVOICE_POSITION_EXTRACTION_WITH_AI_FAILED",

  CHAT_ENTRY_CREATED = "CHAT_ENTRY_CREATED",

  CHECKLIST_TEMPLATE_ACTION_REPLACE_REFERENCES_SUCCESS = 'CHECKLIST_TEMPLATE_ACTION_REPLACE_REFERENCES_SUCCESS',
  CHECKLIST_TEMPLATE_ACTION_REPLACE_REFERENCES_FAILED = 'CHECKLIST_TEMPLATE_ACTION_REPLACE_REFERENCES_FAILED',

  ORGANIZATION_DELETED = 'ORGANIZATION_DELETED',
  ORGANIZATION_DELETED_FAILED = 'ORGANIZATION_DELETED_FAILED',

  ACCESS_KEY_EXPIRED = 'ACCESS_KEY_EXPIRED',
  TAKEN_OVER_ACCESS_KEY_EXPIRED = 'TAKEN_OVER_ACCESS_KEY_EXPIRED',

  UPGRADE_MODULE_RELEASE_JOB_ROUTINE_TEMPLATES_SUCCESS = 'UPGRADE_MODULE_RELEASE_JOB_ROUTINE_TEMPLATES_SUCCESS',
  UPGRADE_MODULE_RELEASE_JOB_ROUTINE_TEMPLATES_FAILED = 'UPGRADE_MODULE_RELEASE_JOB_ROUTINE_TEMPLATES_FAILED',

  ATTRIBUTE_IDENTIFIER_IN_GLOBAL_MODULE = 'ATTRIBUTE_IDENTIFIER_IN_GLOBAL_MODULE',

  TODOS_CHANGED = 'TODOS_CHANGED'

}
